<div class="position-rel">
  <div class='flex-end-ticker-chart ticker-tabs-wrapper'>
    <app-tabs-with-counter
      [tabNamesRaw]="ChartYearsTabs"
      [initialTabIndex]="2"
      (selectedTabEmitter)="onPeriodsNumberChange($event)"
    >
    </app-tabs-with-counter>
  </div>

  <figure class="highcharts-figure"  style="height: 600px;">
    <div id="marketAnalChartTicker"></div>
  </figure>
</div>

